import * as React from "react";

// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { ITheme } from "@fluentui/react";

import { AppThemeConsumer } from "@1js/acui-theme";
import { isReducedAnimations } from "@1js/window-util";

import type { SelectedPivotIndicatorProps } from "./SelectedPivotIndicator.Props";
import {
  SelectedPivotIndicatorDirection,
  selectedPivotIndicatorId,
} from "./SelectedPivotIndicator.Props";
import {
  getSelectedPivotIndicatorClassNames,
  getSelectedPivotIndicatorStyles,
} from "./SelectedPivotIndicator.styles";

export class SelectedPivotIndicator extends React.PureComponent<
  SelectedPivotIndicatorProps,
  {}
> {
  public render() {
    const {
      position,
      offset = 0,
      length,
      thickness = 3,
      appColors,
      showAnimation,
      direction = SelectedPivotIndicatorDirection.Horizontal,
      styles,
      useNextStyles,
      isTabIndicatorRounded,
    } = this.props;
    const animate = showAnimation && !isReducedAnimations();
    return (
      <AppThemeConsumer>
        {(theme: ITheme) => {
          const classNames = getSelectedPivotIndicatorClassNames(
            getSelectedPivotIndicatorStyles(
              position,
              offset,
              length,
              thickness,
              animate,
              direction,
              theme,
              appColors,
              styles,
              useNextStyles,
              isTabIndicatorRounded
            )
          );
          return (
            <div id={selectedPivotIndicatorId} className={classNames.root} />
          );
        }}
      </AppThemeConsumer>
    );
  }
}
